// import { useEffect } from "react";
// import { useNavigate } from "react-router";
// import { displayNotImplemented } from "../../shared/services/Notifications";

const NotImplemented = () => {

    // const navigate = useNavigate()

    // useEffect(()=>{
    //     displayNotImplemented()
    //     // navigate(-1)
    // }, [])

    return (
        <div>
            В разработке
        </div>
    );
}

export default NotImplemented;
